import { render, staticRenderFns } from "./stationOrder.vue?vue&type=template&id=36b39c4a&scoped=true&"
import script from "./stationOrder.vue?vue&type=script&lang=js&"
export * from "./stationOrder.vue?vue&type=script&lang=js&"
import style0 from "./stationOrder.vue?vue&type=style&index=0&id=36b39c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b39c4a",
  null
  
)

export default component.exports